import React, { FC, ReactNode } from "react";
import { cn } from "@/lib/utils";

interface ArrivalStatCardProps {
  icon: ReactNode;
  label: string;
  value: string | number;
  badgeNode?: ReactNode;
  labelClassName?: string;
  valueClassName?: string;
}

export const StatCard: FC<ArrivalStatCardProps> = ({
  icon,
  label,
  value,
  badgeNode,
  labelClassName,
  valueClassName,
}) => (
  <div className="relative flex h-[72px] min-h-[72px] flex-1 flex-row items-center justify-between gap-2 overflow-visible rounded-2xl border border-base-border bg-white p-4">
    {badgeNode ? (
      <div className="pointer-events-auto absolute right-[-7px] top-[0px] z-10 shrink-0">
        {badgeNode}
      </div>
    ) : null}
    <div className="flex min-w-0 items-center gap-2">
      {icon}
      <span className={cn("text-base text-foreground", labelClassName)}>
        {label}
      </span>
    </div>
    <span
      className={cn(
        "shrink-0 text-base font-bold text-[#10B981]",
        valueClassName,
      )}
    >
      {value}
    </span>
  </div>
);
